function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import Debounce from 'react-debounce-component';
import { CSSTransition } from 'react-transition-group';
import classnames from 'classnames';
import { OUT_OF_STOCK_DEBOUNCE_TIMEOUT } from 'swag-common/constants/giveaway.constants';
import classes from './out-of-stock-message.scss';
import animationClasses from './error-appear.anim.scss';
export default class OutOfStockMessage extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "getText", () => {
      const {
        inStockQuantity = null,
        twoLines = false,
        showCompletelyOutOfStockMessage = false,
        showCurrentStockMessage = false
      } = this.props;
      if (showCurrentStockMessage) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, inStockQuantity, twoLines && /*#__PURE__*/React.createElement("br", null), " available");
      }
      if (inStockQuantity === 0 && showCompletelyOutOfStockMessage) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, "Out of", twoLines && /*#__PURE__*/React.createElement("br", null), "stock");
      }
      if (inStockQuantity > 0) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, inStockQuantity, twoLines && /*#__PURE__*/React.createElement("br", null), " available");
      }
      return null;
    });
  }
  render() {
    const {
      className
    } = this.props;
    const text = this.getText();
    return /*#__PURE__*/React.createElement(CSSTransition, {
      in: !!text,
      classNames: animationClasses,
      unmountOnExit: true,
      timeout: OUT_OF_STOCK_DEBOUNCE_TIMEOUT
    }, /*#__PURE__*/React.createElement(Debounce, {
      ms: OUT_OF_STOCK_DEBOUNCE_TIMEOUT
    }, /*#__PURE__*/React.createElement("div", {
      "data-message": "OutOfStock",
      className: classnames(classes.warning, className)
    }, text)));
  }
}